import React from 'react';

import { LinearProgress, Paper } from '@mui/material';

import { FunnelPanel } from '../../components/funnelPanel';
import {
    formatInteger,
    percent
} from '../../utils/numberUtils';

const sellerFirstName = (label) => {
    if (!label || typeof label !== 'string') return 'N/A';
    return label.split(' ').filter(Boolean).at(0);
};

const visibleSellerBreakdown = (sellerBreakdown) => sellerBreakdown.filter((item) => (
    item.label && item.label !== 'Não informado' && !item.label.startsWith('ID ')
));

const statusColors = ['var(--setta-amber)', 'var(--app-text)', '#2ab47d', '#e15e5e'];
const originColors = ['var(--setta-amber)', 'var(--app-text)', '#7b8eec', '#2ab47d'];

export const DashboardPanels = ({ children, funnelData, originBreakdown, sellerBreakdown, statusBreakdown, totalLeads }) => (
    <div className='crm-dashboard-panels'>
        <div className='crm-dashboard-panel-row crm-dashboard-panel-row-funnel'>
            <FunnelPanel funnelData={funnelData} />
        </div>

        {children}

        <div className='crm-dashboard-panel-row crm-dashboard-panel-row-middle'>
            <Paper className='crm-dashboard-panel'>
                <div className='crm-dashboard-panel-header'>
                    <h2 className='crm-dashboard-panel-title'>Análise de Origem de Leads</h2>
                </div>
                <div className='crm-dashboard-origin-list'>
                    {originBreakdown.slice(0, 4).map((item, index) => (
                        <div key={item.id} className='crm-dashboard-origin-item'>
                            <div className='crm-dashboard-origin-header'>
                                <span className='crm-dashboard-origin-label'>{item.label}</span>
                                <span className='crm-dashboard-origin-value'>{formatInteger(item.count)} Leads</span>
                            </div>
                            <LinearProgress className='crm-dashboard-progress origin-progress' variant='determinate' value={percent(item.count, originBreakdown[0]?.count || 1)} style={{ '--progress-color': originColors[index] }} />
                        </div>
                    ))}
                </div>
            </Paper>

            <Paper className='crm-dashboard-panel'>
                <div className='crm-dashboard-panel-header'>
                    <h2 className='crm-dashboard-panel-title'>Rendimento por Representante</h2>
                    <p className='crm-dashboard-panel-subtitle'>Volume mensal de conversão por consultor</p>
                </div>
                <div className='crm-dashboard-seller-chart'>
                    {visibleSellerBreakdown(sellerBreakdown).slice(0, 5).map((item, index, rows) => {
                        const maxValue = rows[0]?.count || 1;
                        const barHeight = `${Math.max((item.count / maxValue) * 100, 28)}%`;
                        const barColor = index === 1 ? 'var(--app-text)' : index === 2 ? 'var(--setta-amber)' : 'var(--app-track)';

                        return (
                            <div key={item.id} className='crm-dashboard-seller-item'>
                                <span className='crm-dashboard-seller-count'>{item.count}</span>
                                <div className='crm-dashboard-seller-bar' style={{ '--bar-height': barHeight, '--bar-color': barColor }} />
                                <span className='crm-dashboard-seller-name'>{sellerFirstName(item.label)}</span>
                            </div>
                        );
                    })}
                </div>
            </Paper>
        </div>

        <div className='crm-dashboard-panel-row crm-dashboard-panel-row-status'>
            <Paper className='crm-dashboard-panel crm-dashboard-status-panel'>
                <div className='crm-dashboard-panel-header'>
                    <h2 className='crm-dashboard-panel-title'>Leads por Status</h2>
                    <p className='crm-dashboard-panel-subtitle'>Distribuição atual do pipeline ativo</p>
                </div>
                <div className='crm-dashboard-status-list'>
                    {statusBreakdown.slice(0, 4).map((item, index) => {
                        const ratio = percent(item.count, totalLeads);
                        return (
                            <div key={item.id} className='crm-dashboard-status-item'>
                                <div className='crm-dashboard-status-header'>
                                    <div className='crm-dashboard-status-label-wrap'>
                                        <span className='crm-dashboard-status-dot' style={{ backgroundColor: statusColors[index] }} />
                                        <span className='crm-dashboard-status-label'>{item.label}</span>
                                    </div>
                                    <div className='crm-dashboard-status-value'>
                                        {formatInteger(item.count)} <span>({ratio}%)</span>
                                    </div>
                                </div>
                                <LinearProgress className='crm-dashboard-progress status-progress' variant='determinate' value={ratio} style={{ '--progress-color': statusColors[index] }} />
                            </div>
                        );
                    })}
                </div>
                <div className='crm-dashboard-status-footer'>
                    <p className='crm-dashboard-eyebrow'>Total de Ativos</p>
                    <h3 className='crm-dashboard-footer-value'>{formatInteger(totalLeads)}</h3>
                </div>
            </Paper>
        </div>
    </div>
);
